const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagTaiwan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "18px",
    height: "12px",
    viewBox: "0 0 480 320",
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    height: 320,
    id: "rect1",
    style: {
      fill: "red"
    },
    width: 480,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("rect", {
    height: 160,
    id: "rect2",
    style: {
      fill: "#0000aa"
    },
    width: 240,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "polygon1",
    points: "180,80 149.0674,87.42212 171.9615,110 141.4620,100.9614 150,131.9615 128.1059,108.8841 120,140 112.5779,109.0674 90,131.9615 99.03857,101.4620 68.03848,110 91.11586,88.10594 60,80 90.93262,72.57788 68.03848,50 98.53798,59.03857 90,28.03848 111.8941,51.11586 120,20 127.4221,50.93263 150,28.03848 140.9614,58.53798 171.9615,50 148.8841,71.89406 180,80 ",
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 80,
    id: "path1",
    rx: 34,
    ry: 34,
    style: {
      fill: "#0000aa"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 80,
    id: "path2",
    rx: 30,
    ry: 30,
    style: {
      fill: "white"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagTaiwan);
export default __webpack_public_path__ + "static/media/flag-taiwan.958612ed54428325a39fb9e6bb45248c.svg";
export { ForwardRef as ReactComponent };